<div class="home_banner--top" *ngIf="!isHideCommonHeader && windowType =='mobile'" [ngClass]="{'home-pg-header': !isUserLoggedin, 'home-pg-header-loggedin':isUserLoggedin}">
  <app-home-games-lang></app-home-games-lang>
</div>

  <div *ngIf="!isHideCommonHeader && windowType !='mobile'" class="home-pg-header__web">
    <app-home-games-lang></app-home-games-lang>
  </div>

<div class="home_banner--bg" [ngClass]="{'notLoggedIn-banner': !isUserLoggedin, 'loggedIn-banner': isUserLoggedin, 'pnp-banner': (isZimplerCountryAllowed === 1), 'non-pnp-banner':  (isZimplerCountryAllowed === 2)}">
  <div class="home_banner--top" *ngIf="!isHideCommonHeader && windowType !='mobile'">
  </div>
  <div class="slider" 
    [ngClass]="{'zimpler_wrap': isZimplerCountryAllowed === 1, 'loggedIn': isUserLoggedin}" *ngIf="banners">
    <div class="slider_container">
      <div [innerHtml]="banners | safeHtml"></div>
      <app-zimpler-quickdeposit *ngIf="!isUserLoggedin && isZimplerCountryAllowed === 1"></app-zimpler-quickdeposit>
    </div>
  </div>

  <div class="slider banner_slider_loader" [ngClass]="{'notLoggedIn': !isUserLoggedin, 'loggedIn': isUserLoggedin, 'pnp-loader': (isZimplerCountryAllowed === 1), 'non-pnp-loader':  (isZimplerCountryAllowed === 2)}" *ngIf="!banners">
    <div class="loader">
      <div class="loader-inner"></div>
    </div>
  </div>
</div>

<div class="banner_footer" *ngIf="!isUserLoggedin">
  <div class="main_wrapper--row">
    <div class="banner_footer--top">
      <p>{{'quickDeposit.registrationContent' | translate}}</p>
    </div>
    <div class="banner_footer--bottom">
      <img class="banner_footer--bottom-img desktop-img" src="{{siteUrlPath}}/{{mediaUrlPath}}/{{isZimplerCountryAllowed === 1 || langCodeBasedPaymentLogosForNonPnp() ? 'payment-logo-pnp.svg' : 'payment-logo.svg' }}" alt="Payment Options">
      <img class="banner_footer--bottom-img mobile-img" src="{{siteUrlPath}}/{{mediaUrlPath}}/{{isZimplerCountryAllowed === 1 || langCodeBasedPaymentLogosForNonPnp() ? 'payment-logo-pnp-mobile.svg' : 'payment-logo-mobile.svg' }}" alt="Payment Options">
    </div>
  </div>
</div> 